import {ExtensionContext} from "@app/common/components/viewers/configurator/extensions/configurator-api-extension"
import {InterfaceDescriptor, ObjectPathPart, StringInfo, objectPathStartsWith} from "@cm/template-nodes"

/** Drops parts whose path is a prefix of another part's path, keeping only the deepest ones. */
export function getLeafAffectedObjectPathParts(affectedObjectPathParts: ObjectPathPart[]): ObjectPathPart[] {
    return affectedObjectPathParts.filter(
        ({path}) => !affectedObjectPathParts.some(({path: otherPath}) => otherPath.length > path.length && objectPathStartsWith(otherPath, path)),
    )
}

export function filterDescriptorsBySelection(context: ExtensionContext): InterfaceDescriptor<unknown, object>[] {
    const {sceneManagerService} = context
    const selectedObjectPathParts = sceneManagerService.$selectedObjectPathParts()

    return sceneManagerService.$descriptorList().filter((descriptor) => {
        const {affectedObjectPathParts} = descriptor.props
        if (!affectedObjectPathParts) return true

        return getLeafAffectedObjectPathParts(affectedObjectPathParts).some((affected) => {
            return selectedObjectPathParts.some((selected) => {
                if (affected.path.length < selected.path.length) {
                    return objectPathStartsWith(selected.path, affected.path)
                } else if (affected.path.length > selected.path.length) {
                    return objectPathStartsWith(affected.path, selected.path)
                } else {
                    return objectPathStartsWith(affected.path, selected.path) && affected.part === selected.part
                }
            })
        })
    })
}

export function getDeepestDescriptor(d: StringInfo[]): StringInfo {
    if (d.length === 0) throw new Error("testCompare: no descriptors provided")

    const depth = (descriptor: StringInfo) => {
        const parts = descriptor.props.affectedObjectPathParts
        if (!parts) return 0
        return parts.reduce((max, {path}) => Math.max(max, path.length), 0)
    }

    let best = d[0]
    let bestDepth = depth(best)
    for (let i = 1; i < d.length; i++) {
        const current = d[i]
        const currentDepth = depth(current)
        if (currentDepth > bestDepth) {
            best = current
            bestDepth = currentDepth
        }
    }
    return best
}

export function findSingleDescriptor<T extends InterfaceDescriptor<unknown>>(descriptors: T[], id: string, errorLabel: string): T {
    //const matches = descriptors.filter((d) => d.props.id.startsWith(idPrefix) && d.props.type === "input")
    const matches = descriptors.filter((d) => d.props.id === id && d.props.type === "input")
    if (matches.length !== 1) {
        throw new Error(`Expected exactly one ${errorLabel} for ${id}, but found ${matches.length}`)
    }
    return matches[0]
}
